import "./prasora-custom-component.scss";
import m from "mithril";
import pf from "../../pf";
import modal from "../../modal/modal";
import randomcolor from "randomcolor";
import cache from "../../cache";

export default () => {
	let styleElement = null;
	let showadmin = false;
	let originalcss = null;
	let customcss = null;
	let loading = true;
	let blockdata = null;
	let appcode = null;
	let standardclass = "basic-style";

	async function GetDataFromCache(appcode, tid) {
		cache.get(appcode, tid).then((r) => {
			if (!blockdata && !!r) {
				blockdata = r;
				loading = false;
				m.redraw();
			}
		});
	}

	async function GetData(appcode, tid, tact, prid) {
		await pf
			.APIAction("GetBlockDataForUT", {
				tid: tid,
				tact: tact,
				prid: prid,
				search: {},
				category: "block",
				sort: {},
				groups: null,
				pagesize: 200,
				pagenum: 1,
			})
			.then((r) => {
				blockdata = r;
				loading = false;

				cache.set(appcode, tid, r);

				m.redraw();
			});
	}

	function GetColor(seed, light) {
		let originalSeed = seed;
		let mySeed = 0;
		let counterSeed = 0;
		let mySeq = 0;
		MyReset();

		let cache = {};

		function myRandom() {
			var x = Math.sin(counterSeed++) * 10000;
			return x - Math.floor(x);
		}

		function MyReset() {
			mySeed = parseInt(originalSeed) + 600000;
			counterSeed = parseInt(originalSeed);
			mySeq = 0;
		}

		return {
			CreateColor: () => {
				mySeq += Math.floor(myRandom() * 1000);

				let finalSeed = mySeed + mySeq * 10;

				let newCol = randomcolor({
					hue: finalSeed % 360,
					luminosity: light,
				});
				// console.log(finalSeed, mySeq, mySeed);

				return newCol;
			},
			Reset: MyReset,
		};
	}

	let myColors = undefined;

	async function SaveCSS() {
		pf.APIAction("SaveOptionsForModuleDesign", {
			did: data.did,
			bid: data.bid,
			options: options,
		}).then((r) => {
			if (r.success) {
				pf.Inform("saved");
			} else pf.Inform(r.error, "error");
		});
	}
	async function GetCSS() {}
	async function SaveCSSLocal() {}
	async function RestoreCSSLocal() {}
	function UpdateCSS() {
		if (styleElement) {
			styleElement.parentNode.removeChild(s);
		}

		if (customcss) {
			styleElement = document.createElement("style");
			styleElement.type = "text/css";
			styleElement.innerHTML = pf.replaceAll(customcss, "&", `#${moduleid} `);
			document.getElementsByTagName("head")[0].appendChild(styleElement);
		}
	}

	return {
		oninit: ({attrs: {tid, prid, blockcode, tact, appcode, blocktitle, blockid}}) => {
			myColors = new GetColor(blockid, "light");
			GetDataFromCache(appcode, tid);
			GetData(appcode, tid, tact, prid);
		},
		view: ({attrs: {tid, prid, blockcode, tact, blocktitle, blockid}}) => {
			if (loading) return m("p", "...loading");
			else {
				myColors.Reset();

				return [
					showadmin &&
						m(
							".prasora-custom-admin-section",
							{
								style: `width: 100vw;
            height: 100vh;
            position: fixed;
            left: 0;
            top: 0;
            background: rgba(69, 168, 255, 1);
            display: grid;
            padding: 10vh 10vw 8vh;
            z-index: 1;`,
							},
							[
								m(
									".prasora-custom-admin-wrapper",
									{
										style: `background-color: white;`,
									},
									[
										m(
											".top-section",
											{
												style: `display: flex; flex-direction: row; gap: 1rem; padding: 0.5rem;`,
											},
											[
												m("button", {type: "button"}, "Configuration"),
												m("button", {type: "button"}, "Template Management"),
											]
										),
										m(".middle-section"),
										m(".bottom-section"),
									]
								),
							]
						),
					m(
						".prasora-custom-project",
						{
							class: [standardclass, blockcode == 300 ? "single-row" : "multi-row"].join(" "),
							// ondblclick: (e) => {
							//     if (e.ctrlKey && e.shiftKey) {
							//         showadmin = true;
							//     }
							// },
						},
						[
							blocktitle && m(".block-title", blocktitle),
							m(".block-table", [
								m(".block-col-headers", [
									blockdata.cols.map((c) => {
										return m(".block-col-header", c.caption);
									}),
								]),
								m(".block-rows", [
									blockdata.rows.map((r) => {
										// console.log(blockcode);
										if (blockcode >= 400) {
											return m(
												".block-row",
												{
													style: `--bg-color: ${myColors.CreateColor()};`,
												},
												[
													m(".row-title", [
														blockdata.cols.map((c, i) => {
															if (i == 0)
																return m(
																	".block-cell",
																	{
																		class: i == 0 ? "first" : null,
																	},
																	[
																		m(".caption", c.caption),
																		m(
																			".value",
																			r[c.name].links && r[c.name].links.length > 0
																				? r[c.name].links.map((a) => {
																						return m(
																							"a",
																							{
																								href: a.url,
																							},
																							a.caption
																						);
																				  })
																				: r[c.name].value
																		),
																	]
																);
														}),
													]),
													m(".row-details", [
														blockdata.cols.map((c, i) => {
															if (i > 0)
																return m(
																	".block-cell",
																	{
																		class: i == 0 ? "first" : null,
																		// style: `--bg-color: ${myColors.CreateColor()};`,
																	},
																	[
																		m(".caption", c.caption),
																		m(
																			".value",
																			r[c.name].links && r[c.name].links.length > 0
																				? r[c.name].links.map((a) => {
																						return m(
																							"a",
																							{
																								href: a.url,
																							},
																							a.caption
																						);
																				  })
																				: r[c.name].value
																		),
																	]
																);
														}),
													]),
												]
											);
										} else {
											return m(".block-row", [
												blockdata.cols.map((c, i) => {
													return m(
														".block-cell",
														{
															class: i == 0 ? "first" : null,
															style: `--bg-color: ${myColors.CreateColor()};`,
														},
														[
															m(".caption", c.caption),
															m(
																".value",
																r[c.name].links && r[c.name].links.length > 0
																	? r[c.name].links.map((a) => {
																			return m(
																				"a",
																				{
																					href: a.url,
																				},
																				a.caption
																			);
																	  })
																	: r[c.name].value
															),
														]
													);
												}),
											]);
										}
									}),
								]),
							]),
						]
					),
				];
			}
		},
	};
};
